import apiClient from './client.js';

/**
 * Fetch pipeline statuses, sorted by order.
 * GET /api/statuses
 */
export async function fetchStatuses () {
  const { data } = await apiClient.get('/statuses');
  const items = data?.items || [];
  return items.sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));
}
